import { useEffect, useState } from 'react';
import './orgAccount.css';
import ReactLoading from 'react-loading';
import errorHandle from '../../utils/errorHandle';
import AccOwner from './orgAccSec/AccOwner';
import AccCompany from './orgAccSec/AccCompany';
import AccAddress from './orgAccSec/AccAddress';
import AccContactPer from './orgAccSec/AccContactPer';
import AccBank from './orgAccSec/AccBank';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { FetchOrgAccount } from './orgAccountFun/fetchOrgAccount';
import OrgInfo from './orgAccSec/orgInfo';
import Dialog from '../../components/dialogModal/dialogModal';
import { toast } from 'react-toastify';
import CharCount from '../../components/charCount/CharCount';
import { editOrgAccount } from './orgAccountFun/editOrgAccount';
import EmptyPage from '../../components/empty-page/emptyPage';
import { getOrganizers } from '../../utils/getOrganizers';
import AccPercentage from './orgAccSec/AccPercentage';
import { getTypeOrg } from '../../utils/getType';

// URL mode letter -> value of the "type" dropdown below
const typeMap = {
    t: 'trip',
    g: 'guide',
    a: 'act',
    c: 'camp',
    camp: 'camp'
};

export default function OrgAccount() {
    const navigate = useNavigate();
    const { orgId, mode } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const [accDetails, setAccDetails] = useState({});
    const [loading, setLoading] = useState(false);
    const serviceType = typeMap[mode] || 'trip';
    // what the backend calls each type: trip | act | gu | camp
    const apiType = getTypeOrg(mode) || 'trip';
    const [modal, setModal] = useState(false);
    const [accountData, setAccountData] = useState({ about: '', logo: '' });
    const [render, setRender] = useState(false);
    const [selectedOrg, setSelectedOrg] = useState(null || orgId);
    const [orgData, setOrgData] = useState([]);
    const type = 'trip';

    const SERVICE_TO_MODE = {
        trip: 't',
        act: 'a',
        camp: 'c',
        guide: 'g'
    };

    const handleServiceType = (e) => {
        const selectedValue = e.target.value;
        console.log(selectedValue, 'selectedValue');

        const newMode = SERVICE_TO_MODE[selectedValue];
        setAccDetails({});
        setSelectedOrg('');
        navigate(`/support/${newMode}/org/account`);
    };

    useEffect(() => {
        async function fetchAccData() {
            if (!selectedOrg && !orgId) return;
            setLoading(true);
            try {
                const data = await FetchOrgAccount({ type: apiType, orgId: selectedOrg || orgId });
                setAccDetails(data);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                errorHandle(error);
            }
        }

        fetchAccData();
    }, [selectedOrg, orgId, apiType]);

    useEffect(() => {
        const fetchOrg = async () => {
            getOrganizers(apiType, setOrgData, setLoading);
        };
        fetchOrg();
    }, [serviceType]);

    const handelLogo = (e) => {
        if (e.target.files) {
            //Without conversiotion to array it we cant store or read it as array
            const selectedFile = e.target.files[0];

            const sizeLimit = 2 * 1024 * 1024; // 2 MB in bytes
            // check if all the files are less than 2mb
            const checkImg = selectedFile.size > sizeLimit;
            if (checkImg) {
                toast.error('Image size should be less than 2 mb');
                return;
            }
            setAccountData((prevState) => {
                return {
                    ...prevState,
                    logo: URL.createObjectURL(selectedFile)
                };
            });
        } else {
            return;
        }
    };

    const handelEdit = () => {
        editOrgAccount(accountData, setLoading, setModal, setRender);
    };

    return (
        <div className='orgAccountDiv'>
            {loading && (
                <div className='loadingBackground'>
                    <ReactLoading type='spin' color='#006aff' className='loadingSpin' />
                </div>
            )}
            <div className='orgPackTripStrap'>
                <div className='orgPackHeadSeaDiv alignCenter'>
                    <h1 className='orgBookingHeading'>Account</h1>
                    {/* <div className="orgPackSearchDiv">
                            <input
                                placeholder="Search your packages"
                                name="orgSearch"
                                value={searchText}
                                className="orgPackSearch"
                                onChange={(sea) =>
                                    handleTextChange(sea, setSearchText)
                                }
                            />
                            <button
                                type="button"
                                onClick={() =>
                                    orgPackSearch(searchText, setSearchRe)
                                }
                                className="orgPackSearchBtn"
                            >
                                Search
                            </button>
                        </div> */}
                    <div>
                        <select
                            name='serviceType'
                            id='serviceType'
                            className='select mr-2'
                            value={serviceType}
                            onChange={(e) => {
                                handleServiceType(e);
                            }}
                        >
                            <option value='trip'>Trip</option>
                            <option value='act'>Activity</option>
                            <option value='camp'>Camp</option>
                            <option value='guide'>Guide</option>
                        </select>
                        <select
                            name='org'
                            id='org'
                            className='select mr-2'
                            value={selectedOrg}
                            onChange={(e) => {
                                const selectedId = e.target.value;
                                setSelectedOrg(selectedId);
                                if (selectedId) {
                                    navigate(`/support/${mode}/org/account/${selectedId}`);
                                }
                            }}
                        >
                            <option value=''>Select Organizer</option>
                            {orgData.map((org) => (
                                <option value={org._id} key={org._id}>
                                    {org.companyName}
                                </option>
                            ))}
                        </select>
                        {/* <button className='orgPackCreateBtn blueBtn' onClick={() => navigate('/org/create/pack')}>
                                Create {window.innerWidth < 768 ? '' : 'Package'}
                            </button> */}
                    </div>
                </div>
                {Object.keys(accDetails).length === 0 && !loading ? (
                    <EmptyPage></EmptyPage>
                ) : (
                    <>
                        <OrgInfo setModal={setModal} accDetails={accDetails} />
                        <AccOwner accDetails={accDetails} />
                        <AccCompany accDetails={accDetails} />
                        <AccAddress accDetails={accDetails} />
                        <AccContactPer accDetails={accDetails} />
                        <AccBank accDetails={accDetails} />
                        <AccPercentage accDetails={accDetails} />
                    </>
                )}
                {modal && (
                    <Dialog openModal={modal} heading={'Edit Account'}>
                        <div className='dialogContent'>
                            <div className=''>
                                <label className='orgAccounProfiletp'>Logo</label>
                                <div className='orgAccImgContainer'>
                                    <input
                                        type='file'
                                        multiple
                                        accept='.jpg, .jpeg, .png'
                                        className=''
                                        onChange={(e) => handelLogo(e)}
                                    />
                                </div>
                            </div>
                            {accountData.logo && (
                                <div className='imgDisplayDiv'>
                                    <img src={accountData.logo} alt='logo' className='wallImgDisp' />
                                </div>
                            )}
                            <label className='orgAccounProfiletp'>About</label>
                            <textarea
                                className='messageArea'
                                value={accountData.about}
                                onChange={(e) =>
                                    setAccountData({
                                        ...accountData,
                                        about: e.target.value
                                    })
                                }
                            />
                            <CharCount string={accountData.about ? accountData.about : ''} min={20} limit={200} />
                            <div className='alignCenter'>
                                <button
                                    className='dialogActBtn cancel'
                                    onClick={() => {
                                        setModal(false);
                                        setAccountData({ logo: '', abount: '' });
                                    }}
                                >
                                    Cancel
                                </button>
                                <button className='dialogActBtn submit' onClick={handelEdit}>
                                    Submit
                                </button>
                            </div>
                        </div>
                    </Dialog>
                )}
            </div>
        </div>
    );
}
